import { NoteDetailFormValue } from '../../../coaching-note/note-detail-form-value.model';
import { TranscriptEntry } from '../../../platform-call';
import { User } from '../../../user/user.model';

import { createNote } from './create-note.function';

export function createNoteFromQuotes(
    selectedQuotes: TranscriptEntry[],
    user: User,
): NoteDetailFormValue {
    const text = (selectedQuotes ?? []).reduce((p, c) => {
        return `${p}${c.text ?? ''}<br/>`;
    }, '');

    return createNote(text, user);
}
